import React, { ReactNode } from 'react';

interface CustomStoryLayoutProps {
  banner?: ReactNode;
  children?: ReactNode;
  title?: ReactNode;
}

const CustomStoryLayout = ({ banner, title, children }: CustomStoryLayoutProps) => {
  return (
    <div className="v2-container pt-5 flex-auto flex flex-col">
      <div className="rounded-[1.25rem] bg-primary-50 flex-auto overflow-hidden">
        {banner}

        <div className="mx-auto max-w-[75rem] px-5 pb-12 pt-5 md:pb-28 md:pt-10">
          {title && (
            <h1 className="text-center text-primary-600 text-3xl md:text-5xl mb-5 md:mb-10">
              {title}
            </h1>
          )}

          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomStoryLayout;
